import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {alabaster, denim, grayscale, white} from '/theme/color/on.color';
import {alto, wineRed} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    backgroundColor: white,
  },
  title: {
    alignSelf: 'flex-start',
  },
  contentContainer: {
    justifyContent: 'space-between',
    flex: 1,
    marginBottom: indent * 2,
  },
  infoContainer: {
    flexDirection: 'row',
  },
  alertIcon: {
    color: wineRed,
    fontSize: 18,
    marginTop: 3,
    marginRight: 8,
  },
  infoText: {
    flexWrap: 'wrap',
    flexShrink: 1,
    marginBottom: 24,
  },
  tileEnabled: {
    backgroundColor: white,
    borderRadius: 8,
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: alto,
    paddingHorizontal: indent,
    paddingVertical: indent * 0.6,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  tileDisabled: {
    backgroundColor: alabaster,
    paddingHorizontal: indent,
    paddingVertical: indent * 0.6,
    borderWidth: 1,
    borderColor: alabaster,
    borderRadius: 8,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  tileHeadingContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  phoneIcon: {
    fontSize: 18,
    marginRight: 6,
  },
  button: {
    borderRadius: 8,
    height: 53,
  },
  selectedIcon: {
    fontSize: 22,
    color: denim,
    marginLeft: 6,
  },
  unSelectedIcon: {
    fontSize: 17,
    borderColor: grayscale,
    borderStyle: 'solid',
    borderWidth: 2.5,
    borderRadius: 2,
    color: white,
    marginLeft: 6,
  },
  checkboxContainer: {
    flexDirection: 'row',
    alignSelf: 'center',
  },
});
